export default __webpack_public_path__ + "static/media/Urban Asset Solutions 1.6 ratio.b3cb6c06.png";